import { Modifier } from './Modifier';

export enum SnapAlign {
	START = 0,
	CENTER = 0.5,
	END = 1
}

export interface SnapOptions {
	align: number | SnapAlign;
	offset: number;
}

export class Snap extends Modifier {
	private options: SnapOptions;

	constructor(options: Partial<SnapOptions> = {}) {
		super();
		this.options = {
			align: SnapAlign.START,
			offset: 0,
			...options
		};
	}

	public snap(value?: number): number {
		value = value ?? this.state.drag;

		const index = this.state.getClosestIndex(value);
		const offsetToIndex: number = this.state.roundToIndex(value);

		const container = this.connection.containerElement;
		const item = this.state.items[index];

		if (!container || !item) return offsetToIndex;

		const containerStyle = window.getComputedStyle(container);
		let margin = containerStyle.marginLeft ? parseFloat(containerStyle.marginLeft) : 0;
		margin += containerStyle.marginRight ? parseFloat(containerStyle.marginRight) : 0;

		const containerRect = container.getBoundingClientRect();
		const itemRect = item.node.getBoundingClientRect();

		const delta = containerRect.width - itemRect.width - margin + this.options.offset;
		const offset = offsetToIndex + delta * this.options.align;
		return offset;
	}
}
